import type {CanvasImage} from './canvas-types';

/** Exact identity wins; legacy CDN filenames are usable only when unambiguous. */
export function chatImageFocusTarget(url:string,images:readonly Pick<CanvasImage,'id'|'src'>[],clientId?:string):string|undefined {
 if(clientId)return images.find(image=>image.id===clientId&&image.src===url)?.id;
 const exact=images.find(image=>image.src===url);
 if(exact)return exact.id;
 const filename=(value:string)=>value.split(/[?#]/)[0].split('/').pop();
 const name=filename(url);
 if(!name)return undefined;
 const candidates=images.filter(image=>filename(image.src)===name);
 return candidates.length===1?candidates[0].id:undefined;
}
